import Badge from "@mui/material/Badge";
import logoSm from "../assets/images/1x/psb-2025-space-logo-sm.png";
import {useNavigate} from "react-router-dom";

export default function LogoBadge(props) {
  const navigate = useNavigate();
  const handleClick = (e) => {
    navigate('/');
  };
  return (
    <Badge>
      <img
        style={{
          height: 'auto',
          width: '42px'
        }}
        onClick={handleClick}
        src={logoSm} className={'logo-sm'}/>
    </Badge>
  )
}